<template>
    <v-dialog v-model="dialog" scrollable persistent :overlay="false" max-width="500px" transition="dialog-transition">
        <v-card class="mx-auto">
            <div class="d-flex align-end my-3">
                <v-card class="green py-4 px-4 ml-6 mr-3 mt-6">
                    <v-icon color="white"> mdi-bookmark </v-icon>
                </v-card>
                <span class="h4 ml-1 mb-n1">任务排序</span>
            </div>

            <v-card-text>
                <div ref="drag-container">
                    <draggable
                        v-model="showTaskList"
                        animation="100"
                        filter="span"
                    >
                        <v-card
                            class="drag-item mb-1"
                            v-for="(element, index) in showTaskList"
                            :key="element._id"
                            style="cursor: pointer;"
                            :data-id="element._id"
                            :data-sort-num="element.sortNum !== undefined ? element.sortNum : index"
                        >
                            <v-card-text class="d-flex align-center ">
                                <v-checkbox v-if="element.visible" v-model="element.visible" :value="false"></v-checkbox>
                                <v-checkbox v-else v-model="element.visible" :value="true"></v-checkbox>
                                <span>{{ `${index + 1}.${element.name}` }}</span>
                            </v-card-text>
                        </v-card>
                    </draggable>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green" dark @click.stop="submit">提交</v-btn>
                <v-btn color="gray" @click.stop="dialog = false">取消</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import draggable from "vuedraggable";
import { mapGetters } from 'vuex';
import { updateTaskSort } from '@/api/task/task'
export default {
    components: {
        draggable
    },
    computed: {
        ...mapGetters(['taskList']),
        dialog: {
            get() {
                if (this.$store.state.task.showTaskSort) {
                   this.initSortable()
                }
                return this.$store.state.task.showTaskSort
            },
            set(val) {
                this.$store.commit("task/SET_TASK_SORT_DIALOG", val);
            }
        }
    },
    data() {
        return {
            Sortable: null,
            list: [],
            showTaskList: [],
            dragNode: null,
        }
    },
    methods: {
        initSortable() {
            this.showTaskList = this.taskList.map(item => {
                const { _id, visible, name, sortNum } = Object.assign({}, item);
                return {
                    _id, visible, name, sortNum
                }
            });
        },
        async submit() {
            let originTaskDataMap = this.taskList.reduce((map,task) => {
                map[task._id] = task;
                return map;
            }, {});

            let arr = [];

            for (let i = 0; i < this.showTaskList.length; i++) {
                const showTaskData = this.showTaskList[i];

                const task = Object.assign({}, originTaskDataMap[showTaskData._id]);
                task.sortNum = i;
                task.visible = showTaskData.visible;
                arr.push(task)
            }

            await updateTaskSort({ arr, })

            this.dialog = false;
            
            this.$store.commit('task/SET_TASK_LIST', arr);
        },

    }
}
</script>